import { Navigate, useLocation } from "react-router-dom";

/**
 * Client-side redirect that preserves the incoming query string.
 * Used for legacy path redirects where search params must survive (e.g. /outlets -> /media-network).
 * Renders <Navigate replace> so the browser never flashes a 404 or intermediate screen.
 */
export default function PreserveQueryRedirect({ to }) {
  const { search } = useLocation();
  const target = search ? `${to}${search}` : to;
  return <Navigate to={target} replace />;
}